var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.401,
    height: 32.001,
    viewBox: "0 0 30.401 32.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFFFFF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.1,30.64V5.36C16.1,2.96,15.076,2,12.532,2H6.068C3.524,2,2.5,2.96,2.5,5.36V30.64C2.5,33.04,3.524,34,6.068,34h6.464C15.076,34,16.1,33.04,16.1,30.64Z",
    transform: "translate(-2.5 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.6,16.24V5.36C26.6,2.96,25.576,2,23.032,2H16.568C14.024,2,13,2.96,13,5.36V16.24c0,2.4,1.024,3.36,3.568,3.36h6.464C25.576,19.6,26.6,18.64,26.6,16.24Z",
    transform: "translate(3.801 -2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.6,22.84V18.36c0-2.4-1.024-3.36-3.568-3.36H16.568C14.024,15,13,15.96,13,18.36v4.48c0,2.4,1.024,3.36,3.568,3.36h6.464C25.576,26.2,26.6,25.24,26.6,22.84Z",
    transform: "translate(3.801 5.801)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.dce43228.svg";
export { ForwardRef as ReactComponent };